import React, { Component } from "react";
import Panel from "../../../../components/panel/Panel";
import PropTypes from "prop-types";
import { appConfig } from "../../../../config/appConfig";
import { connect } from "react-redux";

import { AnimatedView } from "../../../../components";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { createBrowserHistory } from "history";
import "../../../../style/subAdmin/SubAdmin.scss";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../../components";
import loader from "../../../../style/loader/loader.scss";
import { withRouter, Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import isEmpty from "lodash.isempty";
import {aclUtil} from "../../../util"

const history = createBrowserHistory();
let parentCategoryItems = "",
  subCategoryItems = "",
  parentCatTypedisabled = true,
  isLoading = "false",
  isLoad = "false";
class AddCategory extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'ADD_CATEGORY',
      path: ["Home", "Manage Categories", "Add New"],
      links:["home", "categories", "categories/addCategory"],
      catType: "",
      catName: "",
      type: "",
      catstatus: "Active",
      weight: "1",
      parentId: "",
      msg_status: "hide",
      alertMessage: "",
      show: false,
      parentCategories: "",
      catID: "",
      french_catName: "",
      multi_lang: 'no',
      other_link:'',
      target:'',
      subCategories: "",
      subCategoryItems:"",
      SubCatId:""
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.Clear = this.Clear.bind(this);
    this.getSubCategory = this.getSubCategory.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));

    if(siteData){
      if(siteData.multi_lang){
        this.setState({
          multi_lang: siteData.multi_lang
        });
      }
    }
    parentCatTypedisabled = true;
    this.handleDismiss();
    const {
      actions: { clearAlerts }
    } = this.props;
    clearAlerts();
    const {
      actions: { getCategory }
    } = this.props;
    getCategory();
    let catIDParams = this.props.match.params.catID
      ? this.props.match.params.catID
      : "";
    const editLink = this.props.match.params.catID && `addCategory/${this.props.match.params.catID}`
    if (catIDParams !== "") {
      isLoad = "true";
      const {
        actions: { getCategoryDetail }
      } = this.props;
      getCategoryDetail(catIDParams);

      this.state.path = ["Home", "Manage Categories", "Edit Category"];
      this.state.links = ["home", "categories", editLink]
    }
  }

  componentWillReceiveProps(nextProps) {
    let menuAclKey = this.state.menuKey;
    if(this.props.match && this.props.match.params.catID){
      menuAclKey = 'EDIT_CATEGORY';
    }
    if(!aclUtil.isPrimaryMenuAccessible(menuAclKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    
    if (this.props.catStatus !== nextProps.catStatus) {
      if (typeof nextProps.catStatus != "undefined") {
        const {
          actions: { getCategory }
        } = this.props;
        getCategory();
        const {
          actions: { clearAlerts }
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts }
        } = this.props;
        renderAlerts("success", nextProps.catStatus.message);
        this.Clear();
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error) {
      if (typeof nextProps.error != "undefined") {
        const {
          actions: { clearAlerts }
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts }
        } = this.props;
        renderAlerts("warning", nextProps.error);
        isLoading = "false";
        isLoad = "false";
        window.scrollTo(0, 0);
      }
    }

    if (this.props.catdetails !== nextProps.catdetails) {
      if (typeof nextProps.catdetails != "undefined") {
        let category = nextProps.catdetails.data;
        isLoad = "false";
        this.setState({
          catName: category.catName,
          catType: category.catType,
          type: category.type,
          catstatus: category.status,
          weight: category.weight,
          parentId: category.parentID,
          catID: category.catID,
          french_catName: category.french_catName,
          other_link: category.other_link,
          target: category.target,
          SubCatId: category.sub_cat_id,
        });
        if(category.sub_cat_id)
        {
          this.getSubCategory(category.parentID)
        } 
        if (category.type == "Sub-category") {
          parentCatTypedisabled = false;
        }
      }
    }
    if (this.props.updatecat !== nextProps.updatecat) {
      if (typeof nextProps.updatecat != "undefined") {
        const {
          actions: { clearAlerts }
        } = this.props;
        clearAlerts();
        this.handleShow();
        const {
          actions: { renderAlerts }
        } = this.props;
        renderAlerts("success", nextProps.updatecat.message);
        const {
          actions: { getCategory }
        } = this.props;
        getCategory();
        window.scrollTo(0, 0);
      }
    }

    if (typeof nextProps.message != "undefined") {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (
      this.props.catList !== nextProps.catList &&
      !isEmpty(nextProps.catList)
    ) {
      if (nextProps.catList.data && nextProps.catList.data.data) {
        isLoading = "false";
        this.setState({ parentCategories: nextProps.catList.data.data });
        let parentCategories = nextProps.catList.data.data
          ? nextProps.catList.data.data
          : [];
        parentCategoryItems = parentCategories.map((CategoryObject, index) => (
          <option key={index} value={CategoryObject.catID}>
            {CategoryObject.catName}
          </option>
        ));
      }
    }
    if (!isEmpty(nextProps.views) && this.state.parentId) { 
      if (nextProps.views.data) {
        isLoading = "false";
        this.setState({ subCategories: nextProps.views.data });
        let subCategories = nextProps.views.data
          ? nextProps.views.data
          : [];
        subCategoryItems = subCategories.map((SubCategoryObject, index) => (
          <option key={index} value={SubCategoryObject.catID}>
            {SubCategoryObject.catName}
          </option>
        ));
      }
    }
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
    this.setState({ disabled: false }); 
    if(e.target.name=='parentId' && this.state.type=='Second-sub-category') {
      this.getSubCategory(e.target.value)
    }
  }

  getSubCategory(id) {
    if(id) {
      isLoading = "true"; 
      const {
        actions: { getCategoryById }
      } = this.props;
      getCategoryById(id, 0);
    } 
  }

  handlesOntypeChange(e) {
    if (e.target.value == "Category" || e.target.value == "") {
      parentCatTypedisabled = true;
      this.setState({ parentId: "0" });
      isLoading = "false";
    } else {
      isLoading = "true";
      parentCatTypedisabled = false;
      const {
        actions: { getAllCategory }
      } = this.props;
      getAllCategory(1);
      if(e.target.value=='Second-sub-category' && this.state.parentId)
      {
        this.getSubCategory(this.state.parentId)
      } 
    }
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.catName) {
      isError = true;
      this.setState({ catNameError: "red" });
    }
    if (!this.state.catType) {
      isError = true;
      this.setState({ catTypeError: "red" });
    }

    if (!this.state.type) {
      isError = true;
      this.setState({ typeError: "red" });
    } else if (this.state.type == "Sub-category") {
      if (!this.state.parentId) {
        isError = true;
        this.setState({ parentIdError: "red" });
      }
    }
    
    if(this.state.catType=='custom_link') { 
      let regexp =  /^((https?|ftp|smtp):\/\/)+(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      if (regexp.test(this.state.other_link))
      {
        isError = false; 
      }
      else
      {
        isError = true;
        this.setState({ otherlinkError: "red" }); 
      }
    }
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      this.setState({ disabled: true });
      this.handleDismiss();
      this.handleShow();
      if (this.state.catID !== "") {
        const category = {
          catID: this.state.catID,
          catType: this.state.catType,
          catName: this.state.catName,
          type: this.state.type,
          status: this.state.catstatus,
          weight: this.state.weight,
          parentId: this.state.parentId,
          french_catName: this.state.french_catName,
          other_link: (this.state.catType=='custom_link' ? this.state.other_link : null),
          target: (this.state.catType=='custom_link' ? this.state.target : null),
          SubCatId: (this.state.type=='Second-sub-category' && this.state.parentId ? this.state.SubCatId : null),
        }; 
        const {
          actions: { updateCategory }
        } = this.props;
        updateCategory(category);
      } else {
        const category = {
          catType: this.state.catType,
          catName: this.state.catName,
          type: this.state.type,
          status: this.state.catstatus,
          weight: this.state.weight,
          parentId: this.state.parentId,
          french_catName: this.state.french_catName,
          other_link: (this.state.catType=='custom_link' ? this.state.other_link : null),
          target: (this.state.catType=='custom_link' ? this.state.target : null),
          SubCatId: (this.state.type=='Second-sub-category' && this.state.parentId ? this.state.SubCatId : null),
        };

        const {
          actions: { addCategory }
        } = this.props;
        addCategory(category);
      }
    }
  }

  Clear() {
    (this.state.catType = ""),
      (this.state.catName = ""),
      (this.state.type = ""),
      (this.state.catstatus = "Active"),
      (this.state.weight = "1"),
      (this.state.parentId = ""),
      (this.state.french_catName = ""),
      (this.state.disabled = false);
  }

  render() {
    if (parentCategoryItems !== "") {
      isLoading = "false";
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {isLoad == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">Category</header>

            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={8} xs={12} mdOffset={2}>
                    <FormGroup controlId="formname">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Name
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.catName}
                        placeholder="Category Name"
                        onChange={this.handleChange}
                        name="catName"
                        style={{ borderColor: this.state.catNameError }}
                      />
                    </FormGroup>
                    {(this.state.multi_lang == "yes") &&
                      <FormGroup controlId="french_catName">
                        <ControlLabel>
                          {" "}
                          <span style={{ color: "red" }}>*</span> Name (Canadian French)
                        </ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.french_catName}
                          placeholder="Category Name"
                          onChange={this.handleChange}
                          name="french_catName"
                        />
                      </FormGroup>
                    }
                    <FormGroup controlId="formCatType">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Category Type
                      </ControlLabel>

                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="catType"
                        style={{ borderColor: this.state.catTypeError }}
                        onChange={this.handleChange}
                        value={this.state.catType}
                      >
                        <option value="">Select Category Type</option>
                        <option value="local">Local</option>
                        <option value="shopping">Shopping</option>
                        <option value="parentcategory">Parent Category</option>
                        <option value="gift">Gift Voucher</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="products">Products</option>
                        <option value="auctions">Auctions</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formType">
                      <ControlLabel>Type</ControlLabel>
                      <FormControl
                        className="halfWidth"
                        disabled={this.state.catID ? true : false}
                        componentClass="select"
                        name="type"
                        style={{ borderColor: this.state.typeError }}
                        onChange={this.handlesOntypeChange.bind(this)}
                        value={this.state.type}
                      >
                        <option value="">Select Type</option>
                        <option value="Category">Category</option>
                        <option value="Sub-category">Sub Category</option>
                        <option value="Second-sub-category">2nd layer Sub Category</option>
                      </FormControl>
                    </FormGroup>

                    <FormGroup controlId="formParentCategory">
                      <ControlLabel className="halfWidth">
                        Parent Category
                      </ControlLabel>
                      <FormControl
                        componentClass="select"
                        disabled={parentCatTypedisabled}
                        placeholder="Parent Category"
                        name="parentId"
                        value={this.state.parentId}
                        style={{ borderColor: this.state.parentIdError }}
                        onChange={this.handleChange}
                      >
                        <option value="">Select Parent Category</option>
                        {parentCategoryItems}
                      </FormControl>
                    </FormGroup>

                    {(this.state.type=='Second-sub-category' && this.state.parentId) ?
                      <FormGroup controlId="formParentCategory">
                        <ControlLabel className="halfWidth">
                          Sub Category
                        </ControlLabel>
                        <FormControl
                          componentClass="select"
                          disabled={parentCatTypedisabled}
                          placeholder="Parent Category"
                          name="SubCatId"
                          value={this.state.SubCatId}
                          style={{ borderColor: this.state.SubCatIdError }}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Sub Category</option>
                          {subCategoryItems}
                        </FormControl>
                      </FormGroup>
                      :
                      null
                    }

                    {(this.state.catType=='custom_link') ?
                      <React.Fragment>
                        <FormGroup controlId="formStatus">
                          <ControlLabel>Custom Link</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.other_link}
                            placeholder="Custom Link"
                            onChange={this.handleChange}
                            name="other_link"
                            style={{ borderColor: this.state.otherlinkError }}
                          /> 
                        </FormGroup> 
                        <FormGroup controlId="formStatus">
                          <ControlLabel>Target</ControlLabel>
                          <FormControl
                            componentClass="select"
                            name="target"
                            onChange={this.handleChange}
                            value={this.state.target}
                          >
                            <option value="self">None</option>
                            <option value="blank">Blank</option>
                          </FormControl>
                        </FormGroup>
                      </React.Fragment>
                      :
                      null
                    }
                    <FormGroup controlId="formStatus">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="catstatus"
                        onChange={this.handleChange}
                        value={this.state.catstatus}
                      >
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formname">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Weight
                      </ControlLabel>
                      <FormControl
                        type="text"
                        value={this.state.weight}
                        placeholder="Weight"
                        onChange={this.handleChange}
                        name="weight"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="submit"
                id="saveButton"
                disabled={this.props.loading}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/categories`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}
export default compose(withRouter)(AddCategory);



// WEBPACK FOOTER //
// ./src/app/views/admin/categories/addCategory/AddCategory.js